module.exports = __webpack_public_path__ + "img/home.31e9e315.jpg";